'use client';

import Image from 'next/image';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import type { PosterImageProps } from './types';

const DEFAULT_SIZES = '(max-width: 640px) 90vw, (max-width: 1024px) 45vw, (max-width: 1440px) 18vw, (max-width: 1920px) 18rem, 14rem';

const useStyles = createUseStyles(
  {
    poster: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      transition: 'transform 300ms',
      zIndex: 20,
    },
  },
  { name: 'poster-image' },
);

const PosterImage = ({ poster, title, width, height, priority, className, onLoad, sizes = DEFAULT_SIZES }: PosterImageProps) => {
  const classes = useStyles();
  return (
    <Image
      src={poster}
      alt={title || 'Video poster'}
      width={width}
      height={height}
      className={classNames(classes.poster, className)}
      style={{ aspectRatio: `${width}/${height}` }}
      priority={priority}
      fetchPriority={priority ? 'high' : 'auto'}
      onLoad={onLoad}
      sizes={sizes}
    />
  );
};

export default PosterImage;
